import React, { useEffect, useRef, useState } from "react";
import OpenItemList from "./openItemList";
import { useDispatch, useSelector } from "react-redux";
import * as incpectionAction from "../../redux/actions/incpectionAction";
import {
  USER_ID,
  GET_ITEM_LOG,
  GRID_DEFAULT_PAGE_SIZE,
  API_STATUS,
} from "../../constant/constant";
import {
  ACCESS_DENIED,
  VIEW_OPEN_ITEMS_DETAILS,
  OPEN_ITEMS_LIST,
} from "../../constant/routeContant";
import { useLocation, useNavigate } from "react-router-dom";
import { getPreviousRoute } from "../../utils/routeTracker";
import Loader from "../../library/common/Loader";
import { ToastContainer, toast } from "react-toastify";
import { checkPrivileges } from "../../utils/rolesHelper";
import { getFormatedDate, getUserBaseDivisionInfo } from "../../utils/helper";

const OpenItemListContainer = ({ title = "Item Management" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const previousRouteRef = useRef(getPreviousRoute());
  const allowedRoutePrefixes = [OPEN_ITEMS_LIST, VIEW_OPEN_ITEMS_DETAILS];
  const isFromAllowedRouteRef = useRef(
    !!previousRouteRef.current &&
      allowedRoutePrefixes.some((prefix) =>
        previousRouteRef.current.startsWith(prefix)
      )
  );
  const todayDate = new Date();
  const type = window.location.search.slice(6, window.location.search?.length);
  const [activeTab, setActiveTab] = useState(parseInt(type) || 0);
  const [sendEmail, setSendEmail] = useState(false);
  const [fixedCount, setFixedCount] = useState(1);
  const [isCardClicked, setIsCardClicked] = useState(false);
  const [emailType, setEmailType] = useState(false);
  const [timeRange, setTimeRange] = useState(1);
  const [calculatedDate, setCalculatedDate] = useState(new Date());
  const [timeRangeValue, setTimeRangeValue] = useState(false);
  const [onlyCard, setOnlyCard] = useState(true);
  const itemListData = useSelector((state) => state.getItemList?.data);
  const statusItemList = useSelector((state) => state.getItemList?.status);
  const filterObjData = useSelector((state) => state.getItemList);

  const userId = checkPrivileges([12, 117]) ? 0 : parseInt(USER_ID());
  const [statusIds, setStatusIds] = useState(2);
  const { hasBaseDivisionAdminAccess, baseDivisionIds } =
    getUserBaseDivisionInfo();

  const defaultData = {
    userId: userId,
    search: "",
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    projectId: 0,
    divisionId: hasBaseDivisionAdminAccess ? baseDivisionIds : 0,
    itemTypes: GET_ITEM_LOG.All,
    statusIds: parseInt(statusIds) === 1 ? "" : parseInt(statusIds),
    fromDate: calculatedDate !== "" ? getFormatedDate(calculatedDate) : "",
    toDate: getFormatedDate(todayDate),
    status: "",
    isSendMail: false,
  };

  const withDivisionScope = (data) => ({
    ...data,
    divisionId: hasBaseDivisionAdminAccess
      ? baseDivisionIds
      : (data?.divisionId ?? 0),
  });

  const getItemLogAllData = (data, skipFilterUpdate) => {
    const payload = withDivisionScope(data);
    if (payload?.isSendMail) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    if (!skipFilterUpdate) {
      const filtObj = {
        ...payload,
        openItemCount: openItemCount,
      };
      dispatch(incpectionAction.getItemListFilterObj(filtObj));
    }
    dispatch(incpectionAction.getItemList(payload));
  };

  const getItemLogCorrectiveData = (data) => {
    const payload = withDivisionScope(data);
    isFromAllowedRouteRef.current = false;
    const filtObj = {
      ...payload,
      openItemCount: openItemCount,
    };
    dispatch(incpectionAction.getItemListFilterObj(filtObj));
    dispatch(incpectionAction.getItemList(payload));
  };

  const getExportItemListData = (data) => {
    dispatch(incpectionAction.getExportItemList(withDivisionScope(data)));
  };

  useEffect(() => {
    if ((activeTab === 0 || timeRangeValue) && onlyCard) {
      if (isFromAllowedRouteRef.current && filterObjData?.filterObj) {
        getItemLogAllData(filterObjData.filterObj, true);
      } else {
        getItemLogAllData(defaultData);
      }
    }
  }, [activeTab, calculatedDate, timeRangeValue, onlyCard]);

  const handleTimeRangeSetChange = (e) => {
    isFromAllowedRouteRef.current = false;
    setOnlyCard(true);
    setTimeRange(e.target.value);
    setTimeRangeValue(true);
    setActiveTab(0);
    setFixedCount(1);
  };

  const handleViewOnClick = (
    id,
    itemType,
    title,
    origin,
    status,
    itemTypeId,
    rootId,
    subRootId,
    assignedPartyId,
    addedById,
    assignedTo,
    involvedPartyName,
    involvedPartyId,
  ) => {
    setIsCardClicked(true);
    navigate(VIEW_OPEN_ITEMS_DETAILS, {
      state: {
        id: id,
        itemType: itemType,
        title: title,
        origin: origin,
        status: status,
        itemTypeId: itemTypeId,
        rootId: rootId,
        subRootId: subRootId,
        assignedPartyId: assignedPartyId,
        addedById: addedById,
        assignedTo: assignedTo,
        involvedPartyName: involvedPartyName,
        involvedPartyId: involvedPartyId,
      },
    });
  };

  const isGetItemLogLoading = useSelector(
    (state) => state.getItemList?.isLoading,
  );

  const getExportItemListDatass = useSelector(
    (state) => state.getExportItemListDatas,
  );

  useEffect(() => {
    if (
      getExportItemListDatass?.data?.responseMessages?.responseMessage ==
      "Request was successful"
    ) {
      toast("Export Details has been sent to registered mail ID");
      setTimeout(() => {
        window.location.reload();
      }, 3800);
    }
  }, [getExportItemListDatass]);

  const [openItemCount, setOpenItemCount] = useState();

  useEffect(() => {
    const conditionA =
      !isCardClicked &&
      itemListData &&
      parseInt(statusIds) === 2 &&
      fixedCount === 1;
    const conditionB = timeRangeValue && fixedCount === 1;
    if (conditionA || conditionB) {
      setEmailType(true);

      if (isFromAllowedRouteRef.current && filterObjData?.filterObj?.openItemCount) {
        const savedCount = filterObjData.filterObj.openItemCount;
        setOpenItemCount({
          correctivecount: savedCount.correctivecount,
          reprimandscount: savedCount.reprimandscount,
          kudoscount: savedCount.kudoscount,
          actionscount: savedCount.actionscount,
          totalopenitems: savedCount.totalopenitems,
          data: savedCount.data,
        });
      } else {
        const data = itemListData;
        setOpenItemCount({
          correctivecount: itemListData?.result?.noOfViolation,
          reprimandscount: itemListData?.result?.noOfReprimand,
          kudoscount: itemListData?.result?.noOfKudos,
          actionscount: itemListData?.result?.noOfAction,
          totalopenitems: itemListData?.result?.openItemCount,
          data: data,
        });
      }
    }
  }, [fixedCount, activeTab, itemListData, statusIds, timeRangeValue]);
  const showLoader = useSelector(
    (state) => state.getExportItemListDatas?.isLoading,
  );

  useEffect(() => {
    if (statusItemList === API_STATUS.SUCCESS && sendEmail && activeTab === 4) {
      toast("Action has been sent to registered email ID");
    }
  }, [statusItemList, itemListData]);

  useEffect(() => {
    if (timeRange != 1) {
      const days = parseInt(timeRange);
      const today = new Date();
      const calculated = new Date(today);
      calculated.setDate(today.getDate() - (days - 1));
      setCalculatedDate(calculated);
    }
    if (timeRange == 1) {
      setCalculatedDate(null);
    }
  }, [timeRange]);

  return (
    <>
      {checkPrivileges([12, 117, 118, 119]) ? (
        <>
          {showLoader && <Loader />}
          <div className="openItemoverride">
            <div className="insi-stitle titleSaftyOpen">
              <p>{title}</p>
            </div>
          </div>
          <div>
            <ToastContainer />
          </div>
          <OpenItemList
            userId={userId}
            itemListData={isGetItemLogLoading ? [] : itemListData}
            isGetItemLogLoading={isGetItemLogLoading}
            getItemLogCorrectiveData={getItemLogCorrectiveData}
            title={title}
            filterShow
            activeTab={activeTab}
            getItemLogAllData={getItemLogAllData}
            handleViewOnClick={handleViewOnClick}
            statusIds={statusIds}
            setStatusIds={setStatusIds}
            getExportItemListData={getExportItemListData}
            getExportItemListDatass={getExportItemListDatass}
            openItemCount={openItemCount}
            setActiveTab={setActiveTab}
            setIsCardClicked={setIsCardClicked}
            fixedCount={fixedCount}
            setFixedCount={setFixedCount}
            type={type}
            emailType={emailType}
            timeRange={timeRange}
            handleTimeRangeSetChange={handleTimeRangeSetChange}
            calculatedDate={calculatedDate}
            todayDate={todayDate}
            setTimeRangeValue={setTimeRangeValue}
            setOnlyCard={setOnlyCard}
            filterObjDatas={filterObjData}
          />
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default OpenItemListContainer;